var map = {
	"./research-group-1.jpg": "be5c",
	"./research-group-2.jpg": "7ec4",
	"./research-group-3.jpg": "3a5b",
	"./research-group-4.jpg": "90cc",
	"./research-group-5.jpg": "b5bc",
	"./research-group-6.jpg": "447d",
	"./research-group-7.jpg": "7d8b",
	"./research-group-8.jpg": "6496",
	"./research-group-9.jpg": "2789",
	"./research-group-unused1.jpg": "95eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8395";